import React, {useState, useEffect, useRef, useContext} from 'react'
import { Link, Redirect } from 'react-router-dom';
import styled from 'styled-components';
import useModal from './useModal'

import Modal from './Modal'
import './Nav.scss'
import { UserContext } from '../../context/context';
import { history } from '../../_helpers';

const LoginDiv = styled.div`

`
const SideMenuLeft = styled.div`
  
  display:flex;
  align-items: flex-start;
  justify-content: center;

  position: absolute;
  left: 0px;
  top: 0px;
  height: calc(45px);
  /* @media (max-width: 1024px){
    width: 0;
  } */
  /* width: 250px; */
  
  width: 100vw;
  background-color: rgba(0, 0, 0, .8);
  backdrop-filter: saturate(180%) blur(20px);
  z-index: 2;

  -ms-user-select: none; -moz-user-select: -moz-none; -webkit-user-select: none; -khtml-user-select: none; user-select:none;

  transition: .2s;

  img{
      width: 30px;
  }

  >div{
      width: 90%;
      max-width: 1060px;
      /* left:20vw; */
      /* position: absolute; */
      display: flex;
      height: 100%;
      /* border: solid white; */
        /* flex-direction: column; */
      align-items: center;
      justify-content: flex-end;
      div{
            width: 100%;
            height: 100%;

            color: whitesmoke;

            transition: .2s;
            font-size: .8rem;

            display: flex;
            align-items: center;
            justify-content: center;
            /* :active{
                background-color: rgba(50, 50, 50, 1);
            }; */

            :hover{
                /* background-color: rgba(50, 50, 50); */
            }
            
            > a{
                color: whitesmoke;
                text-decoration: none;
                height: 100%;
                z-index: 3;
                display: flex;
                align-items: center;
                
                text-align: center;
                white-space: nowrap;
            }

            button, button:focus, button:active {
                color: whitesmoke;
                background-color: rgba(0,0,0,0);
                border: whitesmoke solid 1px;
                border-radius: 10px;

                text-decoration: none;
                height: 60%;
                z-index: 3;
                display: flex;
                align-items: center;
                
                text-align: center;

                outline:none;
                cursor: pointer;
            }
            :first-child{
              color: whitesmoke;
              display: flex;
              align-items: center;
              justify-content: flex-start;

              /* height: 50px; */

              font-size: 1rem;
              box-sizing: border-box;
              padding-left: 10px;
              margin-right: 30px;
            }
            :nth-last-child(2){
              display: flex;
              /* align-items: flex-end; */
              justify-content: flex-end;
              margin-left: 30px;
              
            }

            :last-child{
              display: flex;
              align-items: center;
              justify-content: flex-end;
              box-sizing: border-box;
              padding-right: 10px;
            }
      }
      
  }
`

const SideMenuSecond = styled.div`
  display:flex;
  align-items: flex-start;
  justify-content: center;

  position: sticky;
  left: 0px;
  top: 0px;
  margin-top: 45px;
  height: calc(45px);
  /* @media (max-width: 1024px){
    width: 0;
  } */
  /* width: 250px; */
  
  width: 100vw;
  background-color: rgba(0, 0, 0, .05);
  backdrop-filter: saturate(180%) blur(20px);
  z-index: 1;

  -ms-user-select: none; -moz-user-select: -moz-none; -webkit-user-select: none; -khtml-user-select: none; user-select:none;

  transition: .2s;

  img{
      width: 30px;
  }

  >div{
      width: 90%;
      max-width: 1060px;
      /* left:20vw; */
      /* position: absolute; */
      display: flex;
      height: 100%;
      /* border: solid white; */
        /* flex-direction: column; */
      align-items: center;
      justify-content: center;
      div{
            width: 100%;
            height: 100%;

            color: whitesmoke;

            transition: .2s;
            font-size: .8rem;

            display: flex;
            align-items: center;
            justify-content: center;
            /* :active{
                background-color: rgba(50, 50, 50, 1);
            }; */

            :hover{
                /* background-color: rgba(50, 50, 50); */
            }
            
            > a{
                color: rgba(0,0,0,0.8);
                text-decoration: none;
                height: 100%;
                z-index: 3;
                display: flex;
                align-items: center;
                
                text-align: center;
                
            }

            button, button:focus, button:active {
                color: whitesmoke;
                background-color: rgba(0,0,0,0);
                border: whitesmoke solid 1px;
                border-radius: 10px;

                text-decoration: none;
                height: 60%;
                z-index: 3;
                display: flex;
                align-items: center;
                
                text-align: center;

                outline:none;
                cursor: pointer;
            }
            
      }
      
  }
`
const Detail = styled.div`
  position:absolute;
  top: 45px;
  /* width: 500px;
  height: 500px; */
  height: 0;
  /* color: black; */
  background-color: rgba(0, 0, 0, .7);
`
// Hook

function useHover() {
  const [value, setValue] = useState(false);
  const ref = useRef(null);
  const handleMouseOver = () => setValue(true);
  const handleMouseOut = () => setValue(false);

  

  useEffect(
    () => {
      const node = ref.current;
      if (node) {
        node.addEventListener("mouseover", handleMouseOver);
        node.addEventListener("mouseout", handleMouseOut);
        return () => {
          node.removeEventListener("mouseover", handleMouseOver);
          node.removeEventListener("mouseout", handleMouseOut);
        };
      }
    },
    [ref.current] // Recall only if ref changes
  );
  return [ref, value];
}

function ComNav(props) {
  // console.log(window.location.pathname)
  const highlight = "rgb(60, 60, 60)"

  const [state, actions] = useContext(UserContext);
  const breakpoint = 768

  const [hoverRef, isHovered] = useHover();
  const [hoverRef2, isHovered2] = useHover();

  const [company, setCompany] = useState();

  const pathname = history.location.pathname.split('/')[2]

  let user = JSON.parse(String(localStorage.getItem('user')))
  let email = String(localStorage.getItem('email'))

  // const [whoru, setWhoru] = useState(null)
  const [school, setSchool] = useState(null)

  const dropdownRef = useRef(null);

  const [isActive, setIsActive] = useState(false);

  

  

  useEffect(()=>{
    
    
    if(user){
      const header = {Authorization: `JWT ${user.token}`}
      async function fetchComData(){
        const res =  fetch(state.awslink + "/user/company/", {
          method: 'GET',
          headers: header,
        })
        .then(response => response.json())
        .then(json=>{
          setCompany(json)
          localStorage.setItem("ComTitle", json.title)
        })
          
      }
  
      if(localStorage.getItem("is_recruiter") === "true") fetchComData();
    }
    
  }, [isActive])

  const {isShowing, setIsShowing} = useModal();

 
  console.log(window.location.pathname.split('/').length)

  return(
    <>
    {localStorage.getItem('is_headhunter') === "true" &&
      <>
        <SideMenuLeft>
            <div>
                <div 
                  style={{backgroundColor:"rgba(0,0,0,0)"}}>
                    <Link to={{pathname: '/', }}>
                      {user?
                        localStorage.getItem("ComTitle") && localStorage.getItem("ComTitle") !== "undefined" ? 
                          localStorage.getItem("ComTitle")
                          : "Expert Group"
                        
                      :"QURATOR"
                      }
                    </Link>
                    
                </div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                

                <div 
                  style={window.location.pathname ==='/login' ? {backgroundColor:highlight}: {}}>
                    {user ?
                    <>
                      <span className={"menu-container"}onClick={()=>setIsActive(!isActive)}>{user.user ? user.user["username"] : email}
                        <nav ref={dropdownRef} className={`menu ${isActive ? 'active' : 'inactive'}`}>
                          <ul>
                            <li><Link to="/recruiter/dashboard">My Qurator</Link></li>
                            <li><Link to="/recruiter/profile">Profile</Link></li>
                            <li><a onClick={()=>{props.logout(); actions.setToken(null); actions.setUser({})}}>Log out</a></li>
                          </ul>
                        </nav>
                      </span>
                      
                    </>
                    :
                    <button onClick={()=>actions.setIsShowing(!state.isShowing)}>
                      로그인
                    </button>
                    }
                    
                </div>

                <div 
                  // style={window.location.pathname ==='/recruiter' ? {backgroundColor:highlight}: {}}
                  >
                    
                    <Link to={{pathname: '/', }}>
                      <button >
                        일반회원
                      </button>
                    </Link>
                </div>

                
            </div>
            {state.user.user ?
            null
            :<Modal
              isShowing={state.isShowing}
              hide={()=>actions.setIsShowing(!state.isShowing)}
              // logout={props.logout}
            />}

        </SideMenuLeft>

        <SideMenuSecond>
          <div>
            <div 
              className={pathname === "raboard" ? "highlight": null}
              style={pathname === "raboard" ? {}: {}}>
                <Link to={{pathname: '/recruiter/raboard', }}>
                  후보자관리
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>

            <div 
              className={pathname ==='userpost' ? "highlight": null}
              style={pathname ==='userpost' ? {}: {}}>
                <Link to={{pathname: '/recruiter/userpost', }}>
                  후보자등록
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>

            <div 
            className={pathname ==='search' ? "highlight": null}
              style={pathname ==='search' ? {}: {}}>
                <Link to={{pathname: '/recruiter/search', }}>
                  인재검색
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>

            <div 
            className={window.location.pathname.split('/').length < 6 && pathname ==='ra' || pathname ==='raadd' ? "highlight": null}
              style={pathname ==='ra' ? {}: {}}>
                <Link to={{pathname: '/recruiter/ra', }}>
                  포지션등록
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>

            <div 
            className={
              (window.location.pathname.split('/').length >= 6 && pathname ==='ra') || 
              window.location.pathname ==='/recruiter/rasearch' ? "highlight": null}
              style={window.location.pathname ==='/recruiter/rasearch' ? {}: {}}>
                <Link to={{pathname: '/recruiter/rasearch', }}>
                  포지션검색
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>

            <div 
            className={pathname ==='messages' ? "highlight": null}
              style={pathname ==='messages' ? {}: {}}>
                <Link to={{pathname: '/recruiter/messages', }}>
                  메세지
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>

            <div 
            className={pathname ==='companypost' ? "highlight": null}
              style={pathname ==='companypost' ? {}: {}}>
                <Link to={{pathname: '/recruiter/companypost', }}>
                  회사정보등록
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>

            <div 
            className={pathname ==='report' ? "highlight": null}
              style={pathname ==='report' ? {}: {}}>
                <Link to={{pathname: '/recruiter/report', }}>
                    기업리포트
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>

          </div>
        </SideMenuSecond>
      </>}
    {localStorage.getItem('is_recruiter') === "true" &&
      <>
        <SideMenuLeft>
            <div>
                <div 
                  style={{backgroundColor:"rgba(0,0,0,0)"}}>
                    <Link to={{pathname: '/', }}>
                      {user?
                        localStorage.getItem("ComTitle") !== "undefined" || 
                        localStorage.getItem("ComTitle") !== null
                         ? localStorage.getItem("ComTitle"): "QURATOR"
                        // company? company[0].title : null
                        // : company? company[0].title : "QURATOR"
                        : "QURATOR"
                        // company? company[0].title : null
                        // : company? company[0].title : "QURATOR"
                      }
                      {/* QURATOR */}
                    </Link>
                    
                </div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                

                <div 
                  style={window.location.pathname ==='/login' ? {backgroundColor:highlight}: {}}>
                    {user ?
                    <>
                      <span className={"menu-container"}onClick={()=>setIsActive(!isActive)}>{user.user ? user.user["username"] : email}
                        <nav ref={dropdownRef} className={`menu ${isActive ? 'active' : 'inactive'}`}>
                          <ul>
                            <li><Link to="/recruiter/dashboard">My Qurator</Link></li>
                            <li><Link to="/recruiter/profile">Profile</Link></li>
                            <li><a onClick={()=>{props.logout(); actions.setToken(null); actions.setUser({})}}>Log out</a></li>
                          </ul>
                        </nav>
                      </span>
                      
                    </>
                    :
                    <button onClick={()=>actions.setIsShowing(!state.isShowing)}>
                      로그인
                    </button>
                    }
                    
                </div>

                <div 
                  // style={window.location.pathname ==='/recruiter' ? {backgroundColor:highlight}: {}}
                  >
                    
                    <Link to={{pathname: '/', }}>
                      <button >
                        일반회원
                      </button>
                    </Link>
                </div>

                
            </div>
            {state.user.user ?
            null
            :<Modal
              isShowing={state.isShowing}
              hide={()=>actions.setIsShowing(!state.isShowing)}
              // logout={props.logout}
            />}

        </SideMenuLeft>

        <SideMenuSecond>
          <div>
            <div 
              className={window.location.pathname ==='/recruiter/raboard' ? "highlight": null}
              style={window.location.pathname ==='/recruiter/raboard' ? {}: {}}>
                <Link to={{pathname: '/recruiter/raboard', }}>
                  후보자관리
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>

            <div 
            className={window.location.pathname ==='/recruiter/search' ? "highlight": null}
              style={window.location.pathname ==='/recruiter/search' ? {}: {}}>
                <Link to={{pathname: '/recruiter/search', }}>
                  인재검색
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>

            <div 
            className={window.location.pathname ==='/recruiter/ra' ? "highlight": null}
              style={window.location.pathname ==='/recruiter/ra' ? {}: {}}>
                <Link to={{pathname: '/recruiter/ra', }}>
                  포지션등록
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>

            <div 
            className={window.location.pathname ==='/recruiter/messages' ? "highlight": null}
              style={window.location.pathname ==='/recruiter/messages' ? {}: {}}>
                <Link to={{pathname: '/recruiter/messages', }}>
                  메세지
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>

            <div 
            className={window.location.pathname ==='/recruiter/companyinfo' ? "highlight": null}
              style={window.location.pathname ==='/recruiter/companyinfo' ? {}: {}}>
                <Link to={{pathname: '/recruiter/companyinfo', }}>
                  회사정보
                    {/* <img src={resource_url+'table.png'}/> */}
                </Link>
            </div>
          </div>
        </SideMenuSecond>
      </>
    }
    {localStorage.getItem('is_headhunter')==="false" &&
    localStorage.getItem('is_recruiter')==="false" &&
      
      history.push('/recruiter/signIn')
    }

      
    </>  
  )
}

export default ComNav;